<template>
	<div class="container">
		<div class="row no-gutters position-relative">
			<div class="position-relative">
				<div class="btn-group">
					<button
						type="button"
						@click.prevent="formData.inputmethod = 'NPep'"
						:class="{
							toggled: formData.inputmethod === 'NPep',
							btn: true,
							'btn-box': true,
							'js-btn-option': true,
						}"
					>
						<span>Total People & Apartments</span>
					</button>

					<button
						type="button"
						@click.prevent="formData.inputmethod = 'RPep'"
						:class="{
							toggled: formData.inputmethod === 'RPep',
							btn: true,
							'btn-box': true,
							'js-btn-option': true,
						}"
					>
						<span>Apartment Size & Occupancy Rates</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'MultifamilyOccupancyMethodToggle',

	data: () => ({
		formData,
	}),
}
</script>

<style scoped>
	.btn-group {
		position:  absolute;
		top: -24px;
		left: 0;
	}
</style>
